import { createSlice } from "@reduxjs/toolkit";
import { api } from "service/api";
import { UnitsApi } from "service/apiVariables";
import { Toast } from "service/toast";
import { setLoader } from "./loader";
import { addQuery } from "helpers/utis";

export const UnitsSlice = createSlice({
  name: "Units",
  initialState: {
    units: null,
    isLoading: false,
    unitData: {},
    activeUnit: null,
    inactiveUnit: null,
  },
  reducers: {
    saveUnitsList: (state, action) => {
      state.units = action.payload || [];
      state.isLoading = false;
    },

    saveUnitData: (state, action) => {
      state.unitData = action.payload || null;
      state.isLoading = false;
    },
    setSelectedActiveUnit: (state, action) => {
      state.activeUnit = action.payload;
    },
    setSelectedInactiveUnit: (state, action) => {
      state.inactiveUnit = action.payload;
    },
  },
});

// get units list
export const getUnitsListAct = (query) => (dispatch) => {
  UnitsApi.getUnitsListApi.addQuery = query;

  addQuery(query || {}, UnitsApi.getUnitsListApi);
  dispatch(setLoader(true));
  console.log("after addQuery full api obj", UnitsApi.getUnitsListApi);
  console.log("after addQuery nested query", UnitsApi.getUnitsListApi.query);
  console.log("final url", UnitsApi.getUnitsListApi.api);

  return new Promise((resolve, reject) => {
    api({ ...UnitsApi.getUnitsListApi })
      .then(({ data }) => {
        dispatch(saveUnitsList(data));
        dispatch(setLoader(false));
        resolve(data);
      })
      .catch((err) => {
        if (err?.status === 400) {
          dispatch(saveUnitsList(err?.data));
          dispatch(setLoader(false));
          resolve(err?.data);
        } else {
          dispatch(setLoader(false));
          reject(Toast({ type: "error", message: err?.message }));
        }
      });
  });
};

// get individual unit detail
export const getUnitByIdAct = (id) => (dispatch) => {
  dispatch(setLoader(true));
  const baseConfig = UnitsApi.getUnitsByIdApi;
  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id),
  };
  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        dispatch(saveUnitData(data?.data));
        dispatch(setLoader(false));
        resolve(data?.data);
      })
      .catch(({ message }) => {
        dispatch(setLoader(false));
        reject(Toast({ type: "error", message }));
      });
  });
};

// add unit
export const createUnitAct = (body) => () => {
  return new Promise((resolve, reject) => {
    api({ ...UnitsApi.createUnitsApi, body })
      .then((data) => {
        Toast({
          type: "success",
          message: data?.message || "Unit added successfully",
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// update unit
export const updateUnitAct = (id, body) => () => {
  const baseConfig = UnitsApi.updateUnitsApi;
  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id),
    body,
  };
  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        Toast({
          type: "success",
          message: data?.message || "Unit updated successfully",
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

// delete unit
export const activateUnitAct = (id, status) => () => {
  const baseConfig = UnitsApi.changeUnitStatusApi;

  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id, status),
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        Toast({
          type: "success",
          message:
            data?.message ||
            `Unit ${status === "active" ? "activated" : "inactivated"} successfully`,
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};
export const deleteUnitAct = (id) => () => {
  const baseConfig = UnitsApi.deleteUnitsApi;

  const apiConfig = {
    method: baseConfig.method,
    baseURL: baseConfig.baseURL,
    api: baseConfig.api(id),
  };

  return new Promise((resolve, reject) => {
    api(apiConfig)
      .then((data) => {
        Toast({
          type: "success",
          message: data?.message || "Unit deleted successfully",
        });
        resolve(data);
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const {
  saveUnitsList,
  saveUnitData,
  setSelectedActiveUnit,
  setSelectedInactiveUnit,
} = UnitsSlice.actions;

export default UnitsSlice.reducer;
